import { connect } from 'react-redux';
import Violations from './Violations';
import { getImporter } from '../../../../../store/importer/selectors';

const mapStateToProps = (state) => ({
  importer: getImporter(state),
});

export default connect(mapStateToProps)(Violations);
